import { shallow } from "zustand/shallow";
import useAppStore from "@duck/app-store";
import { hasPermission } from "./permissions";

/**
 * @param {string|string[]} required
 * @param {{ mode?: "all" | "any" }} [options]
 */
export default function usePermission(required, options = {}) {
  const permissions = useAppStore((state) => state.permissions, shallow);
  return hasPermission(permissions, required, options);
}
